import { IConversationMessageContentProps } from '@modules/conversation-message/ConversationMessageContent/types';
import { alpha, styled } from '@mui/material';
import { Stack } from '@mui/system';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import { SOUNDBOARD_CDN } from 'src/config-global';

export const ConversationMessageContentSoundBoard = ({
  message,
  compact,
  isReply,
}: IConversationMessageContentProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlaySound = () => {
    if (!message.soundBoard) return null;
    const soundUrl = `${SOUNDBOARD_CDN}${message.soundBoard.soundId}`;
    let audio = new Audio(soundUrl);
    audio.addEventListener('ended', () => {
      setIsPlaying(false);
      audio.removeEventListener('ended', () => setIsPlaying(false));
    });
    audio.volume = message.soundBoard.volume || 1;
    audio.play().then(() => console.log('end'));
    setIsPlaying(true);
  };

  return (
    <Stack direction="row" alignItems="center" gap={1.5}>
      <StyledSoundBoardContainer onClick={handlePlaySound}>
        {isPlaying ? (
          <>
            <em-emoji shortcodes={message.soundBoard?.icon} />
          </>
        ) : (
          <>
            <Iconify
              className="showHover"
              icon="tabler:player-play-filled"
              width={36}
            />
            <Iconify
              className="hideHover"
              icon="tabler:speakerphone"
              width={36}
            />
          </>
        )}
      </StyledSoundBoardContainer>
    </Stack>
  );
};

const StyledSoundBoardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  backgroundColor: theme.palette.secondary.main,
  borderRadius: '100%',
  cursor: 'pointer',
  '& .showHover': {
    display: 'none',
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.8),
    '& .showHover': {
      display: 'block',
    },
    '& .hideHover': {
      display: 'none',
    },
  },
  '& em-emoji': {
    '& .emoji-mart-emoji': {
      '& span': {
        fontSize: 36,
        lineHeight: 1,
      },
    },
  },
}));
